import { createFetchAdapter, createHqApi } from '@hq/api-sdk';
import { config } from '../config';
import { getToken, useAuthStore } from '../stores/auth';

/**
 * 三端共用的 SDK 实例：注入 fetch 适配器、令牌来源与 401 处理。
 * 业务页面只依赖 `hq.apply` / `hq.file` 等命名空间，不直接碰 fetch。
 */
export const hq = createHqApi({
  adapter: createFetchAdapter(),
  baseUrl: config.apiBase,
  resBaseUrl: config.resBase,
  resolveToken: getToken,
  onUnauthorized: () => useAuthStore.getState().clear()
});
